import React from "react";
import { CLINIC, whatsappLink } from "../lib/clinic";
import { MessageCircle } from "lucide-react";
import { LogoMark } from "./LogoMark";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-rb-bg-2 border-t border-rb-border"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <LogoMark size={26} className="text-[#93C5FD]" />
            <span className="font-serif-display text-2xl text-rb-text">
              Clenchless
            </span>
          </div>
          <p className="text-sm text-rb-text-2 leading-relaxed mb-5">
            The bruxism clinic. Clinical treatment for teeth grinding, jaw
            clenching and TMJ tension — by Dr. Kartik Patel at Perfect Smile
            Acton.
          </p>
          <div className="flex flex-col gap-2">
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-btn"
              className="btn-primary text-sm inline-flex items-center justify-center gap-2 w-full sm:w-auto"
            >
              <MessageCircle size={14} /> Enquire on WhatsApp
            </a>
            <a
              href={CLINIC.phoneRaw}
              data-testid="footer-call-btn"
              className="text-sm text-rb-text-2 hover:text-rb-text inline-flex items-center gap-1.5"
            >
              or call {CLINIC.phoneDisplay}
            </a>
          </div>
        </div>

        <div>
          <div className="font-overline mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#symptoms" className="text-rb-text-2 hover:text-rb-text">
                Symptoms
              </a>
            </li>
            <li>
              <a href="#quiz" className="text-rb-text-2 hover:text-rb-text">
                30-sec quiz
              </a>
            </li>
            <li>
              <a href="#how" className="text-rb-text-2 hover:text-rb-text">
                How it works
              </a>
            </li>
            <li>
              <a href="#pricing" className="text-rb-text-2 hover:text-rb-text">
                Pricing
              </a>
            </li>
            <li>
              <a href="#faq" className="text-rb-text-2 hover:text-rb-text">
                FAQs
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="font-overline mb-4">Visit</div>
          <p className="text-sm text-rb-text-2 leading-relaxed">
            {CLINIC.address.line1}
            <br />
            {CLINIC.address.line2}
            <br />
            {CLINIC.address.city}, {CLINIC.address.postcode}
          </p>
        </div>

        <div>
          <div className="font-overline mb-4">Contact</div>
          <ul className="space-y-2 text-sm">
            <li>
              <a
                href={CLINIC.phoneRaw}
                className="text-rb-text-2 hover:text-rb-text"
                data-testid="footer-phone"
              >
                {CLINIC.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${CLINIC.email}`}
                className="text-rb-text-2 hover:text-rb-text"
                data-testid="footer-email"
              >
                {CLINIC.email}
              </a>
            </li>
            <li>
              <a
                href={CLINIC.parentUrl}
                target="_blank"
                rel="noreferrer"
                className="text-rb-text-2 hover:text-rb-text"
                data-testid="footer-parent-link"
              >
                Parent practice → {CLINIC.parentBrand}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-rb-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 text-xs text-rb-text-2">
          <div>
            © {new Date().getFullYear()} Clenchless · {CLINIC.domain} · All rights reserved.
          </div>
          <div>
            A sub-brand of{" "}
            <a href={CLINIC.parentUrl} className="underline decoration-[#93C5FD]/40 underline-offset-4">
              restore.dental
            </a>{" "}
            · GDC registered
          </div>
        </div>
      </div>
    </footer>
  );
};
